import axios from "axios";
import camelize from "camelize-ts";

const parseSessionValue = (value: any) => {
    if (typeof value !== "string") return value;

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

export const getSession = async () => {
    const url = `${process.env.REACT_APP_AUTH_SERVICE}/session`;
    axios.defaults.headers.common['Cache-Control'] = 'no-cache'
    const { data: resData } = await axios.get(url);

    const { data } = resData;

    const result = {
        user: parseSessionValue(data.user),
        navigations: parseSessionValue(data.navigations),
        routes: parseSessionValue(data.routes)
    }
    return camelize(result);
}

export const getUser = async () => {
    const { data: resData } = await axios.get(`${process.env.REACT_APP_AUTH_SERVICE}`);

    const { data } = resData;

    return camelize(data);

};
